<script setup>
import DialogCloseBtn from '@/@core/components/DialogCloseBtn.vue'
import {
  redirectToLoginAfterSessionExpiry,
  sessionExpiryState,
} from '@/events/sessionExpiry'
import {
  formattedRemainingTime,
  logoutNow,
  sessionTimeoutState,
  stayLoggedIn,
} from '@/composables/useSessionTimeout'

const handleDialogVisibilityChange = isVisible => {
  if (!isVisible && sessionExpiryState.isVisible)
    redirectToLoginAfterSessionExpiry()
}
</script>

<template>
  <VDialog
    :width="$vuetify.display.smAndDown ? 'auto' : 560"
    :model-value="sessionTimeoutState.warningVisible && !sessionExpiryState.isVisible"
    persistent
  >
    <VCard class="pa-sm-8 pa-5">
      <VCardItem class="text-center pb-2">
        <VIcon
          icon="tabler-clock-exclamation"
          color="warning"
          size="48"
          class="mb-4"
        />
        <VCardTitle class="text-h4 mb-3">
          Your session is about to expire
        </VCardTitle>

        <VCardSubtitle class="text-body-1 text-wrap">
          <span v-if="sessionTimeoutState.expirationKind === 'absolute'">
            You are approaching the maximum session lifetime. Staying logged in cannot extend this limit.
          </span>
          <span v-else>
            Your session will expire due to inactivity unless you stay logged in.
          </span>
        </VCardSubtitle>
      </VCardItem>

      <VCardText class="text-center py-5">
        <div
          class="text-h2 font-weight-bold text-warning"
          aria-live="polite"
        >
          {{ formattedRemainingTime }}
        </div>
      </VCardText>

      <VCardText class="d-flex flex-wrap justify-center gap-3 pt-0">
        <VBtn
          color="primary"
          min-width="150"
          :loading="sessionTimeoutState.extending"
          @click="stayLoggedIn"
        >
          Stay Logged In
        </VBtn>
        <VBtn
          color="secondary"
          variant="outlined"
          min-width="150"
          @click="logoutNow"
        >
          Log Out Now
        </VBtn>
      </VCardText>
    </VCard>
  </VDialog>

  <VDialog
    :width="$vuetify.display.smAndDown ? 'auto' : 520"
    :model-value="sessionExpiryState.isVisible"
    @update:model-value="handleDialogVisibilityChange"
  >
    <DialogCloseBtn @click="redirectToLoginAfterSessionExpiry" />

    <VCard class="pa-sm-8 pa-5">
      <VCardItem class="text-center pb-2">
        <VCardTitle class="text-h4 mb-3">
          {{ sessionExpiryState.title }}
        </VCardTitle>

        <VCardSubtitle class="text-body-1 text-wrap">
          {{ sessionExpiryState.message }}
        </VCardSubtitle>
      </VCardItem>

      <VCardText class="d-flex justify-center pt-4">
        <VBtn
          color="primary"
          min-width="140"
          @click="redirectToLoginAfterSessionExpiry"
        >
          Login
        </VBtn>
      </VCardText>
    </VCard>
  </VDialog>
</template>
